import {
  SET_CART_ITEM_QUANTITY,
  UPDATE_CART_ITEM_QUANTITY,
  CLEAR_CART,
  CLEAR_PRODUCT_CART,
  ADD_CUSTOM_DESIGN,
  REMOVE_CUSTOM_DESIGN,
  UPDATE_CUSTOM_DESIGN_IMAGE,
  UPDATE_CUSTOM_DESIGN_QUANTITY,
  SET_CART_OPEN,
} from "../actions/types";

const INITIAL_STATE = {
  isOpen: false,
  qrCollar: {
    colorQuantities: { orange: 0, cream: 0, black: 0, pink: 0 },
    customDesigns: [],
  },
  gpsTracker: {
    colorQuantities: { orange: 0, cream: 0, black: 0, pink: 0 },
    customDesigns: [],
  },
};

// ფუნქცია საწყისი state-ის გამოსათვლელად
const getPersistedState = () => {
  const savedCart = localStorage.getItem("fethub_cart");
  if (!savedCart) return INITIAL_STATE;

  try {
    const { data, expiry } = JSON.parse(savedCart);
    // თუ 2 საათი (მილიწამებში) გავიდა, ვშლით მონაცემებს
    if (Date.now() > expiry) {
      localStorage.removeItem("fethub_cart");
      return INITIAL_STATE;
    }
    return { ...data, isOpen: false }; // გავხსნათ დახურული კალათით
  } catch (e) {
    return INITIAL_STATE;
  }
};

const PERSISTED_STATE = getPersistedState();

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = PERSISTED_STATE, action) => {
  switch (action.type) {
    case SET_CART_ITEM_QUANTITY: {
      const { productType, color, quantity } = action.payload;
      const cartKey = productType === "gps-tracker" ? "gpsTracker" : "qrCollar";
      return {
        ...state,
        [cartKey]: {
          ...state[cartKey],
          colorQuantities: {
            ...state[cartKey].colorQuantities,
            [color]: Math.max(0, Math.min(15, quantity)),
          },
        },
      };
    }

    case UPDATE_CART_ITEM_QUANTITY: {
      const { productType, color, increment } = action.payload;
      const cartKey = productType === "gps-tracker" ? "gpsTracker" : "qrCollar";
      const currentQty = state[cartKey].colorQuantities[color];
      const newQty = Math.max(0, Math.min(15, currentQty + increment));
      return {
        ...state,
        [cartKey]: {
          ...state[cartKey],
          colorQuantities: {
            ...state[cartKey].colorQuantities,
            [color]: newQty,
          },
        },
      };
    }

    case CLEAR_CART:
      localStorage.removeItem("fethub_cart");
      return INITIAL_STATE;

    case CLEAR_PRODUCT_CART: {
      const { productType } = action.payload;
      const cartKey = productType === "gps-tracker" ? "gpsTracker" : "qrCollar";
      return {
        ...state,
        [cartKey]: {
          colorQuantities: { orange: 0, cream: 0, black: 0, pink: 0 },
          customDesigns: [],
        },
      };
    }

    case ADD_CUSTOM_DESIGN: {
      const { productType } = action.payload;
      const cartKey = productType === "gps-tracker" ? "gpsTracker" : "qrCollar";
      return {
        ...state,
        [cartKey]: {
          ...state[cartKey],
          customDesigns: [
            ...state[cartKey].customDesigns,
            { id: Date.now(), image: null, preview: null, quantity: 1 },
          ],
        },
      };
    }

    case REMOVE_CUSTOM_DESIGN: {
      const { productType, designId } = action.payload;
      const cartKey = productType === "gps-tracker" ? "gpsTracker" : "qrCollar";
      return {
        ...state,
        [cartKey]: {
          ...state[cartKey],
          customDesigns: state[cartKey].customDesigns.filter(
            (design) => design.id !== designId,
          ),
        },
      };
    }

    case UPDATE_CUSTOM_DESIGN_IMAGE: {
      const { productType, designId, image, preview } = action.payload;
      const cartKey = productType === "gps-tracker" ? "gpsTracker" : "qrCollar";
      return {
        ...state,
        [cartKey]: {
          ...state[cartKey],
          customDesigns: state[cartKey].customDesigns.map((design) =>
            design.id === designId ? { ...design, image, preview } : design,
          ),
        },
      };
    }

    case UPDATE_CUSTOM_DESIGN_QUANTITY: {
      const { productType, designId, quantity } = action.payload;
      const cartKey = productType === "gps-tracker" ? "gpsTracker" : "qrCollar";
      const newQty = Math.max(0, Math.min(15, quantity));
      return {
        ...state,
        [cartKey]: {
          ...state[cartKey],
          customDesigns: state[cartKey].customDesigns.map((design) =>
            design.id === designId ? { ...design, quantity: newQty } : design,
          ),
        },
      };
    }

    case SET_CART_OPEN:
      return { ...state, isOpen: action.payload };

    default:
      return state;
  }
};
